export type TileType = 'PDF' | 'EPUB' | 'IMAGE' | 'WEB' | 'DOCX' | 'PPTX' | 'XLSX' | 'AUDIO' | 'VIDEO';

const patterns: [RegExp, TileType][] = [
  [/\.epub$/i, 'EPUB'],
  [/\.pdf$/i, 'PDF'],
  [/\.(gif|jpg|jpeg|png|tiff|svg)$/i, 'IMAGE'],
  [/\.docx$/i, 'DOCX'],
  [/\.pptx$/i, 'PPTX'],
  [/\.xlsx$/i, 'XLSX'],
  [/\.(wav|mp3|m4a)$/i, 'AUDIO'],
  [/\.(mp4|webm)$/i, 'VIDEO'],
];

export const tileTypeDisplayMap: Record<TileType, string> = {
  EPUB: 'ePub',
  PDF: 'PDF',
  IMAGE: 'Image',
  DOCX: 'Word Document',
  WEB: 'Website',
  PPTX: 'PowerPoint',
  XLSX: 'Spreadsheet',
  AUDIO: 'Audio',
  VIDEO: 'Video',
};

export const getTileType = (url: string): TileType => {
  const match = patterns.find(([regex]) => regex.test(url));
  return match?.[1] ?? 'WEB';
};
